import http from '../http';
import { version } from '../version';
const prefix = `${version}/sample`;

export async function insertSample(param) {
  return http.post(prefix + `/insertSample`, param);
}

export async function memberSampleList(param) {
  return http.post(prefix + `/memberSampleList`, param);
}

export async function memberSampleListAdm(param) {
  return http.post(prefix + `/memberSampleListAdm`, param);
}

export async function sampleSearch(param) {
  return http.post(prefix + `/sampleSearch`, param);
}

export async function updateSample(param) {
  return http.post(prefix + `/updateSample`, param);
}

export async function updateSampleStat(param) {
  return http.post(prefix + `/updateSampleStat`, param);
}

export async function sampleMasterList(param) {
  return http.post(prefix + `/sampleMasterList`, param);
}

export async function sampleMasterListAll(param) {
  return http.post(prefix + `/sampleMasterList`, param);
}

export async function sampleMasterDetail(param) {
  return http.post(prefix + `/sampleMasterDetail?code=${param}`);
}

export async function updateSampleMaster(param) {
  return http.post(prefix + `/updateSampleMaster`, param);
}

export async function insertSampleMaster(param) {
  return http.post(prefix + `/insertSampleMaster`, param);
}

export async function sampleRequestandstatus(param) {
  return http.post(prefix + `/sampleRequestandstatus`, param);
}

export async function sampleRequestandstatusadmin(param) {
  return http.post(prefix + `/sampleRequestandstatusadmin`, param);
}

export async function searchproduce(param) {
  return http.post(prefix + `/searchproduce`, param);
}

export async function searchProduceReport(param) {
  return http.post(prefix + `/searchProduceReport`, param);
}

export async function produceupdate(param) {
  return http.post(prefix + `/produceupdate`, param);
}

export async function produceupdate2(param) {
  return http.post(prefix + `/produceupdate2`, param);
}

export async function codedbcreate(param) {
  return http.post(prefix + `/codedbcreate`, param);
}

export async function codedbsearch(param) {
  return http.post(prefix + `/codedbsearch`, param);
}

export async function updateAddress(param) {
  return http.post(prefix + `/updateAddress`, param);
}

export async function selectSampleMailList(lotNo) {
  return http.get(prefix + `/selectSampleMailList?lotNo=${lotNo}`);
}

export async function deleteSampleMailList(param) {
  return http.post(prefix + `/deleteSampleMailList`, param);
}

export async function insertSampleMailList(param) {
  return http.post(prefix + `/insertSampleMailList`, param);
}

export async function dashcount(param) {
  return http.post(prefix + `/dashcount`, param);
}

export async function dashdelivery(param) {
  return http.post(prefix + `/dashdelivery`, param);
}

export async function dashdeliverydelay(param) {
  return http.post(prefix + `/dashdeliverydelay`, param);
}

export async function dashproducedelay(param) {
  return http.post(prefix + '/dashproducedelay', param);
}

export async function dashinspection(param) {
  return http.post(prefix + '/dashinspection', param);
}

export async function dashnew(param) {
  return http.post(prefix + `/dashnew`, param);
}
export async function progress(param) {
  return http.post(prefix + `/progress`, param);
}

export async function resultsList(param) {
  return http.post(prefix + `/resultsList`, param);
}

export async function resultsUpdate(param) {
  return http.post(prefix + `/resultsUpdate`, param);
}

export async function produceReportlist(param) {
  return http.post(prefix + `/produceReportlist`, param);
}

export async function produceReportDetail(param) {
  return http.post(prefix + `/produceReportDetail`, param);
}

export async function produceReportUpdate(param) {
  return http.post(prefix + `/produceReportUpdate`, param);
}

export async function coalist(param) {
  return http.post(prefix + `/coalist`, param);
}
export async function coadetail(param) {
  return http.post(prefix + `/coadetail`, param);
}
export async function coaUpdate(param) {
  return http.post(prefix + `/coaUpdate`, param);
}

export async function saveTotalCoaDetail(param) {
  return http.post(prefix + `/saveTotalCoaDetail`, param, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function coaPDFupload(form) {
  return http.post(prefix + `/coaPDFupload`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function msdsPDFupload(form) {
  return http.post(prefix + `/msdsPDFupload`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function sendHistoryList(param) {
  return http.post(prefix + `/sendHistoryList`, param);
}

export async function manualMailSend(param) {
  return http.post(`${version}/mail/manual`, param);
}

// MSDS 자동생성 미리보기 — lot의 PDF를 blob으로 받아 화면에서 확인(저장 안 함)
export async function getMsdsAutoPreview(lotNo) {
  return http.get(`${version}/sample/msdsAutoPreview?lotNo=${encodeURIComponent(lotNo)}`, { responseType: 'blob' });
}

// MSDS 자동생성 미리보기(HTML) — 저장 없이 렌더된 HTML 문자열을 받아 앱 내 미리보기(WYSIWYG)로 표시
export async function getMsdsAutoPreviewHtml(lotNo) {
  return http.get(`${version}/sample/msdsAutoPreviewHtml?lotNo=${encodeURIComponent(lotNo)}`);
}

// MSDS 현재본 미리보기(HTML) — 최신 발행본(edited/auto) S3 저장 HTML 로드(수정셀 하이라이트 포함), 없으면 자동생성
export async function getMsdsCurrentPreviewHtml(lotNo) {
  return http.get(`${version}/sample/msdsCurrentPreviewHtml?lotNo=${encodeURIComponent(lotNo)}`);
}

// 양산용 MSDS 파일 즉시 삭제 — 남은 파일명 리스트를 Coalist msdspdf_path1~5에 바로 반영(S3 보존)
export async function deleteMsdsProductionFile(lotNo, msdsFileNames) {
  return http.post(`${version}/sample/deleteMsdsProductionFile`, { lotNo, msdsFileNames });
}

// MSDS 자동발행 사전검증 — 차단/경고 사유 검사(발행 없음). res.data.data = { canPublish, blocks[], warnings[] }
export async function msdsValidate(lotNo) {
  // 자동생성 화면은 자체 진행 오버레이를 띄우므로 전역 로딩바는 끔(스피너 2개 겹침 방지)
  return http.get(`${version}/sample/msdsValidate?lotNo=${encodeURIComponent(lotNo)}`, { skipLoadingBar: true });
}

// [CONDPANEL] MSDS 판정 조건 — 미리보기 좌측 패널용(수령업체/고객구분/성분 포함여부와 그 결과)
export async function msdsConditions(lotNo) {
  return http.get(`${version}/sample/msdsConditions?lotNo=${encodeURIComponent(lotNo)}`, { skipLoadingBar: true });
}

// MSDS 자동생성 발행 — 생성+S3박제+issued_document 새 버전, blob PDF 반환
// origin(자동생성/재발행)은 서버가 발행 직전 현재문서 유무로 판정한다
export async function msdsPublish(lotNo, memberId) {
  return http.post(`${version}/sample/msdsPublish?lotNo=${encodeURIComponent(lotNo)}&memberId=${encodeURIComponent(memberId)}`, null, { responseType: 'blob', skipLoadingBar: true });
}

// LOC 자동발행 사전검증 — { canPublish, blocks[] } (경고 케이스 없음)
export async function locValidate(lotNo) {
  // 자동생성 화면은 자체 진행 오버레이를 띄우므로 전역 로딩바는 끔(스피너 2개 겹침 방지)
  return http.get(`${version}/sample/locValidate?lotNo=${encodeURIComponent(lotNo)}`, { skipLoadingBar: true });
}

// LOC 자동생성 미리보기(HTML) — 룰엔진 생성본(저장 없음)
export async function getLocAutoPreviewHtml(lotNo) {
  return http.get(`${version}/sample/locAutoPreviewHtml?lotNo=${encodeURIComponent(lotNo)}`);
}

// LOC 현재본 미리보기(HTML) — 최신 발행본 S3 저장 HTML 로드(수정셀 하이라이트 포함), 없으면 자동생성
export async function getLocCurrentPreviewHtml(lotNo) {
  return http.get(`${version}/sample/locCurrentPreviewHtml?lotNo=${encodeURIComponent(lotNo)}`);
}

// LOC 자동생성 발행 — 생성+S3박제+issued_document 새 버전, blob PDF 반환
export async function locPublish(lotNo, memberId) {
  return http.post(`${version}/sample/locPublish?lotNo=${encodeURIComponent(lotNo)}&memberId=${encodeURIComponent(memberId)}`, null, { responseType: 'blob', skipLoadingBar: true });
}

// LOC 편집본 발행 — 미리보기에서 수정한 HTML(body)을 보내 PDF 렌더+S3박제+auto_edited/reissue_edited 버전 저장
export async function locPublishEdited(lotNo, code, html, reason, memberId) {
  const qs = `lotNo=${encodeURIComponent(lotNo)}&code=${encodeURIComponent(code)}&reason=${encodeURIComponent(reason)}&memberId=${encodeURIComponent(memberId)}`;
  return http.post(`${version}/sample/locPublishEdited?${qs}`, html, { headers: { 'Content-Type': 'text/html' }, responseType: 'blob' });
}

// MSDS 편집본 발행 — 미리보기에서 수정한 HTML(body)을 보내 PDF 렌더+S3박제+auto_edited/reissue_edited 버전 저장
export async function msdsPublishEdited(lotNo, code, html, reason, memberId) {
  const qs = `lotNo=${encodeURIComponent(lotNo)}&code=${encodeURIComponent(code)}&reason=${encodeURIComponent(reason)}&memberId=${encodeURIComponent(memberId)}`;
  return http.post(`${version}/sample/msdsPublishEdited?${qs}`, html, { headers: { 'Content-Type': 'text/html' }, responseType: 'blob' });
}

// 발행문서(issued_document) PDF를 id로 받아 blob 반환
export async function getIssuedDocFile(id) {
  return http.get(`${version}/sample/issuedDocFile?id=${encodeURIComponent(id)}`, { responseType: 'blob' });
}

// lot의 현재 발행문서(is_latest='Y') 목록. docType 옵션(MSDS 등)
export async function getIssuedDocs(lotNo, docType) {
  const dt = docType ? `&docType=${encodeURIComponent(docType)}` : '';
  return http.get(`${version}/sample/issuedDocs?lotNo=${encodeURIComponent(lotNo)}${dt}`);
}

// 발행문서(issued_document) 논리삭제 — is_latest='N' (행·S3 PDF 보존)
export async function deleteIssuedDoc(id, memberId) {
  return http.post(`${version}/sample/issuedDocDelete?id=${encodeURIComponent(id)}&memberId=${encodeURIComponent(memberId)}`);
}
